import React from 'react';
import {Skeleton} from '@mui/material';

export default function ButtonSkeleton() {
  return <Skeleton height='2.25rem' width='14.5rem' variant='rounded' style={{margin: '4px'}} />;
}
